var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 25V11.875C7.5 10.8203 6.62109 10 5.625 10H1.875C0.820312 10 0 10.8789 0 11.875V24.9414C0 25.9375 0.820312 26.7578 1.875 26.7578H5.625C6.62109 26.875 7.5 26.0547 7.5 25ZM30 11.9336C30 10.3516 28.7109 9.12109 27.1875 9.12109H18.5742C19.9219 6.89453 20.625 4.375 20.625 3.49609C20.625 2.08984 19.5117 0.625 17.6953 0.625C14.0039 0.625 16.1719 5.13672 11.3672 8.94531L10.4297 9.70703C9.72656 10.293 9.375 11.0547 9.375 11.875C9.375 11.9336 9.375 11.875 9.375 11.875V21.25C9.375 22.1875 9.78516 23.0078 10.4883 23.5352L12.4805 25C14.1211 26.2305 16.0547 26.875 18.1055 26.875H21.5625C23.0859 26.875 24.375 25.6445 24.375 24.1211C24.375 23.8867 24.3164 23.6523 24.2578 23.4766C25.4297 23.125 26.25 22.0703 26.25 20.7812C26.25 20.2539 26.0742 19.7852 25.7812 19.375C27.1289 19.082 28.125 17.9688 28.125 16.6211C28.125 15.8594 27.832 15.2148 27.3633 14.6875C28.8281 14.6289 30 13.3984 30 11.9336Z",
    fill: "#DDF0FE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default ForwardRef;